<!--代理记账-->
<!--wj-->
<template>
  <div class="dljz">
    <detail-title></detail-title>
    <el-row class="Plan-heard" style="padding-top:5rem;">
      <el-col :span="24" class="Plan-col">
        <img src="../assets/image/fwbg.jpg" />
      </el-col>
    </el-row>
    <el-row class="hn-body">
      <el-col :span="24" class="Plan-col">
        <p class="BE-title">
          <strong>代理记账</strong>
        </p>
        <p class="hn-info">- 汇聚全球资源 投资发展热土 -</p>
        <el-form ref="form" :model="form" label-width="0px" :rules="rules" class="hnzx-form">
          <el-form-item>
            <el-input v-model="form.name" placeholder="公司名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="form.type" placeholder="企业规模" :popper-append-to-body="false">
              <el-option
                v-for="item in qytype"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="phone" class="be-phone">
            <el-input v-model="form.phone" :maxlength="11" placeholder="请输入手机号">
              <span slot="suffix" class="el-input__icon">修改</span>
            </el-input>
          </el-form-item>
          <p style="line-height: 2.5;">
            <strong>其他服务：</strong>
          </p>
          <el-form-item class="BE-other">
            <el-checkbox-group v-model="form.other" v-for="m in Othertype" :key="m.id">
              <el-checkbox :label="m.name"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item style="text-align: center;">
            <button
              type="button"
              class="hn-buttons"
              :disabled="showBtn"
              @click="zixunBtn('form')"
            >立即预约</button>
          </el-form-item>
          <el-carousel
            height="22px"
            direction="vertical"
            :autoplay="true"
            indicator-position="none"
            :interval="3000"
          >
            <el-carousel-item v-for="item in list.data" :key="item.esdmId">
              <p class="BE-carousel">
                <img src="../assets/image/ico-new.svg" />
                <span>{{item.esdmTime}}</span>分钟前，
                <span>{{item.esdmTel}}</span>
                {{item.esdmContent}}
              </p>
            </el-carousel-item>
          </el-carousel>
          <p class="BE-count" v-if="list.count">
            累计办理
            <span>{{list.count}}</span>件
          </p>
        </el-form>
      </el-col>
    </el-row>
    <div v-if="espmDesc" class="BE-html" v-html="espmDesc"></div>
    <!-- 立即咨询 -->
    <div class="es-shaow" v-if="showTip">
      <div class="es-shaow-in">
        <div class="es-shaow-head">
          <el-row>
            <el-col :span="24" style="text-align:right;">
              <img src="../assets/image/interact-btn-close.png" @click="CloseTip()" />
            </el-col>
          </el-row>
        </div>
        <div class="es-content">
          <p>{{tip}}</p>
        </div>
        <div class="es-footer" @click="CloseTip()">我知道了</div>
      </div>
    </div>
    <share-wechat></share-wechat>
  </div>
</template>
<script>
import DetailTitle from "@/components/DetailTitle";
import { eventBus } from '@/assets/js/eventBus';
import ShareWechat from "@/components/ShareWechat";
import Axios from "axios";
export default {
  data() {
    var phones = (rule, value, callback) => {
      if (!value) {
        this.showBtn = false;
        return callback(new Error("电话不能为空"));
      } else {
        callback();
      }
    };
    return {
      list: [],
      form: {
        name: "",
        phone: "",
        type: "",
        other: [],
      },
      rules: {
        phone: [{ validator: phones, trigger: "blur" }],
      },
      qytype: [
        { id: 1, name: "小规模纳税人" },
        { id: 2, name: "一般纳税人" },
      ],
      Othertype: [
        { id: 1, name: "代理记账" },
        { id: 2, name: "旧账梳理" },
      ],
      espmDesc: "",
      showTip: false,
      tip: "",
      showBtn: false,
    };
  },
  mounted() {
    const that = this;
    that.getList();
    var shareList={
      title: "代理记账",
      content: "创业扶持，代账服务再升级，资深会计团队",
    }
    eventBus.$emit("shareList",shareList);
  },
  methods: {
    //获取消息和详情
    getList() {
      const that = this;
      var param = {
        condition: "代理记账",
      };
      Axios.post(that.$store.state.APIURLS + "Esdm/findByPage", param).then(
        function (res) {
          if (res.data.code == 200) {
            res.data.data.data.forEach((e) => {
              var reg = /^(\d{3})\d*(\d{4})$/;
              var str2 = e.esdmTel.replace(reg, "$1****$2");
              e.esdmTel = str2;
            });
            that.list = res.data.data;
          }
        }
      );
      Axios.get(
        that.$store.state.APIURLS + "Espm/findByType?espmType=代理记账"
      ).then(function (res) {
        if (res.data.code == 200) {
          that.espmDesc = res.data.data.espmAppContent;
        }
      });
    },
    //立即咨询
    zixunBtn(formName) {
      const that = this;
      that.showBtn = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var name = "";
          if (that.form.name) {
            if (name == "") {
              name = "企业名称：" + that.form.name;
            } else {
              name = name + "," + "企业名称：" + that.form.name;
            }
          }
          if (that.form.type) {
            if (name == "") {
              name = "企业规模：" + that.form.type;
            } else {
              name = name + "," + "企业规模：" + that.form.type;
            }
          }
          if (that.form.other.length > 0) {
            if (name == "") {
              name = "其他服务需求：" + that.form.other.join(",");
            } else {
              name = name + "," + "其他服务需求：" + that.form.other.join(",");
            }
          }
          const reg = /^[0-9]{1,}$/;
          var num = "";
          if (!reg.test(that.form.phone)) {
            that.showBtn = false;
            that.$toast({
              message: "请输入正确的手机号",
              type: "success",
              position: "bottom",
              duration: "2000",
            });
            return false;
          } else {
            num = that.form.phone;
          }
          setTimeout(() => {
            that.showBtn = false;
          }, 3000);
          var param = {
            escmType: "代理记账",
            escmDesc: name,
            escmTel: num,
            escmActive: "未沟通",
          };
          Axios.post(that.$store.state.APIURLS + "Escm/hnAdd", param).then(
            function (res) {
              that.showTip = true;
              that.tip = res.data.msg;
            }
          );
        } else {
          that.showBtn = false;
          return false;
        }
      });
    },
    //关闭提示弹窗
    CloseTip() {
      const that = this;
      that.showTip = false;
    },
  },
  components: {
    DetailTitle,
    ShareWechat
  },
};
</script>
